<script>
import {
  EXCLUDED_NOTIFICATION_NAMES,
  EXCLUDED_EMAIL_NOTIFICATION_NAMES,
} from '@router/constant.js'
import axios from 'axios'
export default {
  name: 'NotificationsSettings',
  props: {
    notificationSettingsVisible: {
      type: Boolean,
      required: true,
    },
    notificationSettings: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    settingsForm: [],
    isLoading: false,
  }),
  computed: {
    availableSettings() {
      return this.notificationSettings.filter(
        ({ id }) => !EXCLUDED_NOTIFICATION_NAMES.includes(id)
      )
    },
    currentNotificationSettings() {
      return this.$store.state.auth.currentUser.notification_settings || []
    },
  },
  created() {
    this.settingsForm = this.notificationSettings.map(({ id }) => {
      const [browser, email] = this.isEnabled(id)
      return { browser, email }
    })
  },
  methods: {
    onSaveClick() {
      this.isLoading = true
      axios
        .post('/api/v1/set_notification_settings', [null, ...this.settingsForm])
        .then(({ data }) => {
          this.isLoading = false
          alert('You settings have been successfully updated!')
        })
        .catch(() => alert('Something went wrong.'))
    },
    hideNotificationSettings() {
      this.$emit('hide-notification-settings')
    },
    isEligibleForEmail(id) {
      return !EXCLUDED_EMAIL_NOTIFICATION_NAMES.includes(id)
    },
    isEnabled(id) {
      const {
        browser_disabled: browser,
        email_disabled: email,
      } = this.currentNotificationSettings.find(
        ({ notification_id: notificationId }) => notificationId === id
      ) || { browser_disabled: false, email_disabled: false }

      return [!browser, !email]
    },
  },
}
</script>

<template>
  <BaseModalWindow
    modalcls="user-edit w-full max-w-1.95xl bg-white rounded-xl mx-auto px-10 py-8 shadow-box relative left-0"
    :visible="notificationSettingsVisible"
    @close="hideNotificationSettings"
  >
    <template v-slot:body>
      <h3 class="block pb-6 italic font-brandon text-blue-darker text-35xl">
        NOTIFICATION SETTINGS
      </h3>

      <table class="w-full table-auto">
        <thead>
          <tr>
            <th scope="Settings"></th>
            <th scope="Browser">Browser</th>
            <th scope="Email">Email</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="({ id, name }, index) in availableSettings" :key="id">
            <td
              class="py-2 leading-relaxed text-black border-b border-gray-light"
              >{{ name }}</td
            >
            <td class="py-2 text-center border-b border-gray-light">
              <input
                v-model="settingsForm[index].browser"
                type="checkbox"
                class="checkbox"
              />
            </td>
            <td class="py-2 text-center border-b border-gray-light">
              <input
                v-if="isEligibleForEmail(id)"
                v-model="settingsForm[index].email"
                type="checkbox"
                class="checkbox"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="flex justify-end mt-6">
        <button
          class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
          :class="{ 'text-gray bg-gray': isLoading }"
          :disabled="isLoading"
          @click="onSaveClick"
          v-text="isLoading ? 'Saving...' : 'Save'"
        />
        <button
          class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
          @click="hideNotificationSettings"
        >
          Cancel
        </button>
      </div>
    </template>
  </BaseModalWindow>
</template>
